
        export default {
          mounted() {
            this.el.addEventListener("click", () => this.capture())
          },

          capture() {
            const stage = document.getElementById(this.el.dataset.stage)
            if (!stage) return

            // Szene (viewBox 400x260, RFC 0016) und Figur (200x220, RFC 0013) liegen
            // beide schon als Inline-SVG im DOM, fertig gezeichnet. `cloneNode` holt
            // genau die Art, die gerade dasteht — kein Nachzeichnen.
            const sceneBox = stage.querySelector(".pet-stage__scene")
            const scene = sceneBox && sceneBox.querySelector("svg")
            // `.pet-sprite__svg` sitzt auf dem <span>-Wrapper, den `Creature.creature`
            // rendert — das SVG liegt darin. Ein Klon des <span> wäre ein HTML-Element
            // in einem SVG-Dokument: er würde stumm nichts zeichnen.
            const sprite = stage.querySelector(".pet-sprite__svg svg")
            if (!scene || !sprite) return

            const W = 400, H = 260, SCALE = 2
            const night = stage.dataset.night === "true"
            const season = (stage.className.match(/season-(\w+)/) || [])[1]
            const weather = (stage.className.match(/weather-(\w+)/) || [])[1]

            const sceneClone = scene.cloneNode(true)
            sceneClone.setAttribute("x", 0)
            sceneClone.setAttribute("y", 0)
            sceneClone.setAttribute("width", W)
            sceneClone.setAttribute("height", H)

            // Auf die Standlinie (y=214) gesetzt, mittig — dieselben Anker wie live.
            // Der Klon trägt die neutrale Ruhepose: die Idle-Animation hängt am Wrapper,
            // nicht am SVG-Inhalt. Ein Standbild aus der Mitte eines Hüpfers sähe aus
            // wie ein Fehler; die ruhende Figur sieht aus wie ein Portrait.
            const fw = 150, fh = 165, fx = (W - fw) / 2, fy = 214 - fh
            const figure = sprite.cloneNode(true)
            figure.setAttribute("width", fw)
            figure.setAttribute("height", fh)
            figure.setAttribute("x", fx)
            figure.setAttribute("y", fy)
            // Tönung und Saum (RFC 0047) stehen nicht im Markup, sondern als
            // `filter`-Kette im Stylesheet — der nackte Klon käme ungetönt und ohne
            // Kante heraus (Issue #204). Gerade das Bild braucht die Kante am
            // dringendsten: es verlässt die App und landet auf einem Grund, den
            // niemand hier kennt. Also abgelesen und inline geschrieben, dasselbe
            // „vom lebenden Element ablesen" wie bei Schmutz und Funken in `overlay`.
            //
            // Bewusst die berechnete Kette statt zwei nachgebauter `drop-shadow()`:
            // ändert jemand die Ringe in app.css, ändert sich das geteilte Bild mit.
            // Die Kondition (`scruffy` entsättigt) hängt eine Ebene höher am <span>
            // und bleibt weiter außen vor — siehe `overlay`.
            figure.style.filter = getComputedStyle(sprite).filter

            // Die Grundfläche in der Farbe, die #pet-stage gerade trägt — abgelesen vom
            // selben DOM-Element, das den Zustand schon führt (kein zweiter Wahrheitsort).
            const ground = getComputedStyle(stage).backgroundColor
            // Nacht: das Blau, das die Szene live über ::after bekommt (data-night),
            // hier als gemaltes Rechteck über der Szene, unter der Figur — das Tier
            // schläft, es verblasst nicht.
            // ponytail: Overlay statt SVG-<filter>. Reicht das Dunkel nicht, ist der
            // brightness/saturate-Filter der Upgrade-Pfad (RFC 0034, offene Frage).
            const nightFill = night
              ? getComputedStyle(sceneBox, "::after").backgroundColor
              : null

            const svg =
              `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}">` +
              `<rect width="${W}" height="${H}" fill="${ground}"/>` +
              new XMLSerializer().serializeToString(sceneClone) +
              (nightFill ? `<rect width="${W}" height="${H}" fill="${nightFill}"/>` : "") +
              this.weatherMarks(season, weather) +
              new XMLSerializer().serializeToString(figure) +
              this.overlay(stage.querySelector(".pet-condition"), fx, fy, fw, fh) +
              this.overlay(stage.querySelector(".pet-grime"), fx, fy, fw, fh) +
              new XMLSerializer().serializeToString(this.signature(W, H)) +
              `</svg>`

            const img = new Image()
            img.onload = () => {
              const canvas = document.createElement("canvas")
              canvas.width = W * SCALE
              canvas.height = H * SCALE
              canvas.getContext("2d").drawImage(img, 0, 0, W * SCALE, H * SCALE)
              canvas.toBlob(blob => blob && this.offer(blob), "image/png")
            }
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg)
          },

          // Schmutz (RFC 0003) und die radiant-Funken (RFC 0020) sind — anders als
          // die Wetterpartikel — echte Inline-SVGs im DOM und teilen die viewBox der
          // Figur (200x220), also klonbar wie sie. Nur hängen Farbe (currentColor
          // über --color-grime/--color-shine) und die Sichtbarkeit je Stufe
          // (data-grime/data-condition → opacity der Gruppen) an externem CSS: der
          // nackte Klon rendert schwarz und alle Gruppen sichtbar. Also lesen wir
          // Farbe und je-Gruppe-opacity vom lebenden Element ab und schreiben sie
          // inline — dasselbe „vom DOM ablesen, flach nachmalen" wie bei Nacht/Wetter.
          // Auf die Figuren-Box gelegt, sitzen die Formen bei jeder Art am selben Fleck.
          //
          // :scruffy klont bewusst NICHT mit: das ist ein CSS-`filter` auf der Figur
          // (Entsättigen), kein Form-Element. Eine Form über fremder Silhouette wäre
          // „Kreis auf dem Tier" (RFC 0020) — wie die Nacht ein eigener Filter-Pfad,
          // hier außen vor.
          overlay(el, x, y, w, h) {
            if (!el) return ""
            const clone = el.cloneNode(true)
            clone.style.color = getComputedStyle(el).color
            clone.setAttribute("x", x)
            clone.setAttribute("y", y)
            clone.setAttribute("width", w)
            clone.setAttribute("height", h)
            const live = el.querySelectorAll(":scope > g")
            clone.querySelectorAll(":scope > g").forEach((g, i) => {
              g.setAttribute("opacity", getComputedStyle(live[i]).opacity)
            })
            return new XMLSerializer().serializeToString(clone)
          },

          // Die Live-Partikel sind Pseudoelemente und nicht klonbar. Statt sie zu
          // rekonstruieren, malt die Aufnahme eine ruhige, feste Handvoll — ein
          // Standbild ist ohnehin statisch, die eingefrorene Flocke ist ehrlicher als
          // eine, die mitten im Fall abgeschnitten wurde. Deckt die live sichtbaren
          // Fälle: Regen, Winterschnee, Herbstlaub, Frühlingsblüten.
          weatherMarks(season, weather) {
            const dot = (x, y, r, f) => `<circle cx="${x}" cy="${y}" r="${r}" fill="${f}" opacity="0.7"/>`
            const leaf = (x, y, rx, ry, f) => `<ellipse cx="${x}" cy="${y}" rx="${rx}" ry="${ry}" fill="${f}" opacity="0.7"/>`
            const drop = (x, y, f) => `<rect x="${x}" y="${y}" width="1.4" height="9" rx="0.7" fill="${f}" opacity="0.6"/>`
            if (weather === "rain") {
              const c = "#5a7fb0"
              return drop(70, 40, c) + drop(150, 90, c) + drop(250, 50, c) +
                drop(320, 120, c) + drop(110, 165, c) + drop(300, 200, c)
            }
            if (season === "winter") {
              const c = "#bcd0e6"
              return dot(60, 50, 3, c) + dot(150, 90, 2, c) + dot(250, 45, 2.5, c) +
                dot(330, 120, 2, c) + dot(100, 170, 3, c) + dot(290, 190, 2.5, c)
            }
            if (season === "autumn") {
              const c = "#c67a3a"
              return leaf(70, 50, 5, 3, c) + leaf(160, 95, 3, 5, c) + leaf(260, 55, 4, 2.5, c) +
                leaf(320, 130, 5, 3, c) + leaf(110, 175, 3, 5, c)
            }
            if (weather === "special" && season === "spring") {
              const c = "#f0a6b8"
              return leaf(70, 50, 4, 3, c) + leaf(160, 95, 3, 4, c) + leaf(260, 55, 4, 2.5, c) +
                leaf(320, 130, 4, 3, c) + leaf(110, 175, 3, 4, c)
            }
            return ""
          },

          // Leiser Absender (RFC 0034, offene Frage: entschieden). Echtes `<text>`,
          // Systemschrift statt eingebettetem Font: kein neues Asset, keine CSP-
          // Änderung (`font-src 'self'` bleibt unberührt, es wird nichts geladen).
          // Anders als der `foreignObject`-Weg oben ist das hier natives SVG, das
          // die Browser-eigene Rasterisierung genauso zeichnet wie die Pfade und
          // Flächen daneben — der Name kommt im Bild an, nur der Schriftschnitt
          // variiert leicht je Gerät. `textContent` (nicht String-Concat) serialisiert
          // XML-sicher, auch bei Namen mit `&`, `<` o.ä. Klein, gedämpft, in der Ecke,
          // nie über der Figur (fx/fy/fw/fh bleiben unberührt).
          signature(w, h) {
            const text = document.createElementNS("http://www.w3.org/2000/svg", "text")
            text.setAttribute("x", w - 8)
            text.setAttribute("y", h - 8)
            text.setAttribute("text-anchor", "end")
            text.setAttribute("font-family", "system-ui, sans-serif")
            text.setAttribute("font-size", "9")
            text.setAttribute("fill", "#fff")
            text.setAttribute("fill-opacity", "0.55")
            text.setAttribute("stroke", "#1a1a1a")
            text.setAttribute("stroke-opacity", "0.3")
            text.setAttribute("stroke-width", "2")
            text.setAttribute("paint-order", "stroke")
            text.textContent = `${this.el.dataset.name || "Tama"} · Tama`
            return text
          },

          // `canShare({files})` ist die ehrliche Erkennung: nicht nur „share existiert",
          // sondern „dieses Gerät teilt auch Dateien". Schlägt sie fehl (Desktop),
          // lädt derselbe Klick das Bild herunter. Beide Wege enden bei einem Bild in
          // der Hand des Nutzers — nichts verlässt das Gerät über unseren Kanal.
          offer(blob) {
            const name = (this.el.dataset.name || "tama").replace(/[^\w-]+/g, "_")
            const file = new File([blob], `${name}.png`, {type: "image/png"})
            if (navigator.canShare && navigator.canShare({files: [file]})) {
              navigator.share({files: [file]}).catch(() => {})
            } else {
              const a = document.createElement("a")
              a.href = URL.createObjectURL(blob)
              a.download = file.name
              a.click()
              // Ein Tick später, nicht sofort: der Download startet asynchron, das
              // Widerrufen liefe synchron — der Browser müsste die URL auflösen,
              // nachdem sie schon zurückgezogen wurde. Chromium hält eine Referenz
              // und liefert trotzdem, verlassen kann man sich darauf nicht. Ganz
              // weglassen geht auch nicht: dann lebt die URL bis zum Reload.
              setTimeout(() => URL.revokeObjectURL(a.href), 0)
            }
          }
        }
      